module.exports = __webpack_public_path__ + "img/logo-title-b.e8b96fe8.svg";